import { type NavigateOptions, type To, useNavigate as useRouterNavigate } from 'react-router-dom';

// react-router 7 types navigate() as `void | Promise<void>`, which Sonar reports as a floating promise on every call.
interface Navigate {
    (to: To, options?: NavigateOptions): void;
    (delta: number): void;
}

export const useNavigate = (): Navigate => useRouterNavigate() as Navigate;
